export interface SupportConfig {
  privacyPolicyRedirect?: string;
}
